import { Panel } from "../../components/panels/Panel";
import { DiorDigitalTwin } from "./dior-components/DiorDigitalTwin";
import { DiorKanban } from "./dior-components/DiorKanban";
import { useEffect, useRef, useState } from "react";
import { useSocket } from "../../contexts/SocketContext";
import {
  computeCartsErrors, computeCartsFinished, getFlattenPoolsList,
  isCartCurrentError,
  POOLS_GROUPS_LINE_1
} from "../../services/live-interface/dior-interface-service";


export const DiorLivePage = () => {

  const EXPIRATION_DURATION = 10 * 60;

  const { socket, subscribeToEvent, unsubscribeFromEvent } = useSocket();
  const [currentData, setCurrentData] = useState([]);
  const poolsPreviousData = useRef([]);
  const previousCartsErrors = useRef({});
  const previousCartsFinished = useRef([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      const toRemove = previousCartsFinished.current.filter(i => i.stop_time < now - EXPIRATION_DURATION).map(i => i.tag_id);
      previousCartsFinished.current = previousCartsFinished.current.filter(i => i.stop_time >= now - EXPIRATION_DURATION);
      toRemove.forEach(id => delete previousCartsErrors.current[id]);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!socket) return;

    const handleReceivedData = (data) => {
      console.log(data);
      setCurrentData(data.data);

      if (data?.data !== null && data?.data !== undefined && data?.data?.length > 0) {
        previousCartsErrors.current = computeCartsErrors(data.data, poolsPreviousData.current, previousCartsErrors.current);
        previousCartsFinished.current = computeCartsFinished(data.data, poolsPreviousData.current, previousCartsFinished.current);

        poolsPreviousData.current = data.data;
      }
    };

    subscribeToEvent('current_data', handleReceivedData);

    return () => {
      unsubscribeFromEvent('current_data', handleReceivedData);
    };
  }, [socket]);

  return (
    <Panel title="PRODUCTION LINE" category="main">
      <div className="flex flex-col w-full h-full gap-4 justify-center">

        {/* Data block */}
        {/*<div className="flex w-full gap-4 h-1/4">*/}
        {/*  <Panel noHeader={true} className="w-full rounded-md">Data</Panel>*/}
        {/*  <Panel noHeader={true} className="w-full rounded-md">Data</Panel>*/}
        {/*  <Panel noHeader={true} className="w-full rounded-md">Data</Panel>*/}
        {/*  <Panel noHeader={true} className="w-full rounded-md">Data</Panel>*/}
        {/*</div>*/}

        <div className="flex w-full gap-4 h-full">

          {/* Digital twin */}
          <DiorDigitalTwin currentData={currentData} cartsErrors={previousCartsErrors.current} />

          {/* Kanban */}
          <DiorKanban currentData={currentData} cartsErrors={previousCartsErrors.current} cartsFinished={previousCartsFinished.current} />

        </div>
      </div>
    </Panel>
  );
};